import React from 'react';
import { Dialog, Box, Typography, Button } from '@mui/material';
import styles from './ConfirmModal.module.scss';

interface ConfirmModalProps {
  open: boolean;
  title?: string;
  description?: string | React.ReactNode;
  children?: React.ReactNode;
  onClose: () => void;
  onConfirm: () => void;
  confirmText?: string;
  cancelText?: string;
  loading?: boolean;
  isDanger?: boolean;
  confirmDisabled?: boolean;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  open,
  title = 'Confirm Action',
  description,
  children,
  onClose,
  onConfirm,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  loading = false,
  isDanger = false,
  confirmDisabled = false,
}) => {
  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      classes={{ paper: styles.dialogPaper }}
      disableRestoreFocus
    >
      <Typography variant="h6" className={styles.title}>
        {title}
      </Typography>

      {description && (
        <Typography variant="body1" className={styles.description}>
          {description}
        </Typography>
      )}

      {children}

      <Box className={styles.actions}>
        <Button onClick={onClose} className={styles.cancelBtn} disabled={loading}>
          {cancelText}
        </Button>
        <Button
          variant="contained"
          onClick={onConfirm}
          className={`${styles.confirmBtn} ${isDanger ? styles.danger : ''}`}
          disabled={loading || confirmDisabled}
        >
          {loading ? 'Processing...' : confirmText}
        </Button>
      </Box>
    </Dialog>
  );
};

export default ConfirmModal;
